import Shipment from '../../../types/api/shipment'
import { isShipmentStarted } from '../shipment/is-shipment-started'

export function getShipmentTotalReservedAmount(shipment: Shipment): number {
    const seenReserveIds = new Set<string>()
    let total = 0

    for (const requirement of shipment.materialRequirements || []) {
        for (const config of requirement.configurations || []) {
            for (const stock of config.material?.stocks || []) {
                for (const reserve of stock.stock_reserves || []) {
                    if (reserve.shipment?.documentId !== shipment.documentId) {
                        continue
                    }

                    if (seenReserveIds.has(reserve.documentId)) {
                        continue
                    }

                    seenReserveIds.add(reserve.documentId)
                    total += reserve.amount || 0
                }
            }
        }
    }

    return total
}

export function shouldValidateReserves(shipment: Shipment): boolean {
    if (shipment.print_job) {
        return true
    }

    return isShipmentStarted(shipment)
}
